var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("header-programa", {
                    attrs: { programa: _vm.solicitud?.programa },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-overlay",
            { attrs: { show: false } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "md",
                            label: _vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.aprendizaje"
                            ),
                            "label-for": "form-aprendizaje",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: { name: "form-aprendizaje", rows: "4" },
                            model: {
                              value: _vm.testimonioForm.aprendizaje,
                              callback: function ($$v) {
                                _vm.$set(_vm.testimonioForm, "aprendizaje", $$v)
                              },
                              expression: "testimonioForm.aprendizaje",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.testimonioForm.aprendizaje.required
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.testimonioForm.aprendizaje.maxLength
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.maxlength", {
                                      max: 500,
                                    })
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.esReadOnly
                ? _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _vm.esEscritura
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-lg btn-block",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.desactivarBoton,
                                },
                                on: { click: _vm.guardarTestimonio },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.actividadesRetribucion.acciones.guardarSeccion"
                                      )
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }